import { Box, Flex, Icon } from "@chakra-ui/react";

const BlogLeftArrowIcon = ({ size = "20px", color = "white", ...props }) => {
  return (
    <svg
      width="44"
      height="44"
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M27.5452 31.1213C27.9354 30.7311 27.9357 30.0985 27.5459 29.7079L19.8548 22L27.5459 14.2921C27.9357 13.9015 27.9354 13.2689 27.5452 12.8787L26.3736 11.7071C25.9831 11.3166 25.3499 11.3166 24.9594 11.7071L15.3736 21.2929C14.9831 21.6834 14.9831 22.3166 15.3736 22.7071L24.9594 32.2929C25.3499 32.6834 25.9831 32.6834 26.3736 32.2929L27.5452 31.1213Z"
        fill={color}
      />
      <rect
        x="1"
        y="1"
        width="42"
        height="42"
        rx="15"
        stroke={color}
        strokeWidth="2"
      />
    </svg>
  );
};
export default BlogLeftArrowIcon;
